import {
  makeStyles,
  Typography,
  Box,
  Divider,
  Button,
  TextField,
  FormHelperText,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { useMemo, useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context";
import FieldProduct from "./refill-field-product";
import Field from "../field";
import { useForm, Controller } from "react-hook-form";
import { Autocomplete } from "@material-ui/lab";
import { productsServices } from "../../services";
export default function RefillCategoryForm({ onSubmit, isEdit, data }) {
  const [options, setOptions] = useState({ loading: true, value: [] });
  const [selectedSample, setSelectedSample] = useState(null);
  const [productsRefill, setProductsRefill] = useState({});
  const [productsError, setProductsError] = useState(false);
  const { register, handleSubmit, errors, reset, trigger, control } = useForm(
    isEdit && {
      defaultValues: { status: false },
    }
  );
  const { authState, signOut } = useContext(AuthContext);
  const classes = useStyles();

  async function getLabProducts() {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const labId =
        user.role._id === "5fdb9e3db3bfce86908e440f"
          ? "ALL"
          : user.laboratory["_id"];
      const { status, response } = await productsServices.getProducts({
        laboratoryId: labId,
        page: 1,
        limit: 9999,
        token: authState.token,
      });
      if (status === 200) {
        setOptions(() => ({ loading: false, value: response.products }));
      } else if (status === 401) {
        signOut();
      } else setOptions(() => ({ loading: false, value: [] }));
    } catch (e) {
      console.log(e);
    }
  }
  async function restoreRefillCategory() {
    if (!data) return;
    const { products, _id: categoryId, name: categoryName, status } = data;
    let restoreFormProducts = {};
    const restoreProductsRefill = products.reduce((acc, cur) => {
      const {
        productInfo: { _id: productId, name: productName },
        refillTo,
      } = cur;
      restoreFormProducts[productId] = String(refillTo);
      return {
        ...acc,
        [productId]: { _id: productId, name: productName, refillTo },
      };
    }, {});
    setProductsRefill(restoreProductsRefill);
    // console.log(restoreFormProducts);

    reset({
      name: categoryName,
      status: data.status === "active",
      ...restoreFormProducts,
    });
    setTimeout(() => {
      trigger(["name", "status", ...Object.keys(restoreFormProducts)]);
    }, 0);
  }
  useEffect(() => {
    getLabProducts();
  }, []);

  useEffect(() => {
    if (isEdit) restoreRefillCategory();
  }, [data]);

  const addRefillCategory = async (form) => {
    const data = Object.values(productsRefill);
    if (data.length < 1) {
      setProductsError(true);
      return;
    }
    const products = Object.values(productsRefill).map((p) => ({
      productId: p._id,
      refillTo: parseInt(p.refillTo),
    }));
    await onSubmit({
      products,
      name: form.name,
      ...(isEdit ? { status: form.status ? "active" : "inactive" } : {}),
    });
  };
  const toRender = useMemo(() => {
    return Object.values(productsRefill).map((p) => {
      const { _id, name, refillTo } = p;
      return (
        <FieldProduct
          value={refillTo}
          key={_id}
          label={name}
          placeholder="1"
          onDelete={() => {
            setSelectedSample(null);
            setProductsRefill((prev) => {
              const { [_id]: _, ...rest } = prev;
              return rest;
            });
          }}
          onChangeQty={(value) => {
            const valueNumber = Number(value);
            if (valueNumber < 0) return;
            setProductsRefill((prev) => ({
              ...prev,
              [_id]: { ...prev[_id], refillTo: value },
            }));
          }}
          name={`${_id}`}
          inputRef={register({
            required: "Cantidad requerida",
            min: {
              value: 0,
              message: "Cantidad mayor o igual a 0",
            },
          })}
          inputProps={{ min: 0 }}
          error={errors[`${_id}`] ? true : false}
          helperText={errors[`${_id}`] ? errors[`${_id}`].message : ""}
        />
      );
    });
  }, [productsRefill, errors]);

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit(addRefillCategory)}
        style={isEdit && !data ? { userSelect: "none", opacity: "0.8" } : {}}
      >
        <Box component={"section"} className={classes.section_form}>
          <Typography variant="h6">Categoria</Typography>
          <Divider style={{ marginBottom: 12, marginTop: 6 }} />
          <Field
            id="name"
            placeholder="Nombre de categoria"
            label="Nombre"
            name="name"
            inputRef={register({
              required: "Nombre requerido",
              minLength: {
                value: 5,
                message: "El nombre debe ser de al menos 5 letras",
              },
            })}
            error={errors[`name`] ? true : false}
            helperText={errors[`name`] ? errors[`name`].message : ""}
          />
          {isEdit && (
            <Controller
              name="status"
              control={control}
              render={({ value, onChange }) => (
                <FormControlLabel
                  control={
                    <Switch
                      name="status"
                      color="primary"
                      checked={value}
                      onChange={(e) => onChange(e.target.checked)}
                    />
                  }
                  label="Activo"
                />
              )}
            />
          )}
        </Box>
        <Box component={"section"} className={classes.section_form}>
          <Typography variant="h6">Asignar a productos</Typography>
          <Divider style={{ marginBottom: 12, marginTop: 6 }} />
          <Box className={classes.list_fields}>{toRender}</Box>
          <Autocomplete
            loading={options.loading}
            disabled={options.loading}
            className={classes.autocomplete}
            id="sample-product"
            options={options.value}
            getOptionLabel={(option) => option.name}
            fullWidth
            getOptionDisabled={(option) =>
              Object.keys(productsRefill).includes(option._id)
            }
            value={selectedSample}
            onChange={(event, newValue) => {
              if (newValue === null) return;
              const { _id } = newValue;
              setProductsError(false);
              setProductsRefill((prev) => ({
                ...prev,
                [_id]: { ...newValue, refillTo: 0 },
              }));
              setSelectedSample(newValue);
            }}
            getOptionSelected={(option, value) => option._id === value._id}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                variant="outlined"
                label="Selecciona una muestra"
                error={productsError}
              />
            )}
          />
          {productsError && (
            <FormHelperText error>
              Debe definir al menos un producto para esta categoría
            </FormHelperText>
          )}
        </Box>
        <Button
          className={classes.submit_button}
          color="primary"
          variant="contained"
          type="submit"
          style={{ textTransform: "none" }}
        >
          Guardar
        </Button>
      </Box>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  submit_button: {
    boxShadow: `0 0 0 18px ${theme.palette.background.paper}`,
    width: "100%",
    marginTop: theme.spacing(2),
  },
  section_form: {
    margin: theme.spacing(2),
  },
  list_fields: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  autocomplete: {
    marginTop: 12,
    "& fieldset": {
      borderRadius: theme.spacing(4),
    },
  },
}));
